import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function About() {
    const { t } = useI18n();

    return (

        <>
            <>
                <Header />
                <>

                    {/* Page Header Section Start */}
                    <div className="page-header bg-section parallaxie">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* Page Header Box Start */}
                                    <div className="page-header-box">
                                        <h1 className="text-anime-style-3" data-cursor="-opaque">{t('pages.aboutTitle')}</h1>

                                    </div>
                                    {/* Page Header Box End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page Header Section End */}
                    {/* About Us Section Start */}
                    <div className="about-us">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-xl-6">
                                    {/* About Us Images Start */}
                                    <div className="about-us-images">
                                        {/* About Image Box 1 Start */}
                                        <div className="about-image-box-1">
                                            {/* About Us Image 1 Start */}
                                            <div className="about-us-img-1">
                                                <figure className="image-anime">
                                                    <img src="images/Untitled design (15).png" alt="" />
                                                </figure>
                                            </div>
                                            {/* About Us Image 1 End */}
                                            {/* About Us Image 2 Start */}
                                            <div className="about-us-img-2">
                                                <figure className="image-anime">
                                                    <img src="images/Konark Festival 2.png" alt="" />
                                                </figure>
                                            </div>
                                            {/* About Us Image 2 End */}
                                        </div>
                                        {/* About Image Box 1 End */}
                                        {/* About Image Box 2 Start */}
                                        <div className="about-image-box-2">
                                            <div className="about-experience-box">
                                                <img src="images/icon-about-experience-box.svg" alt="" />
                                                <h2>
                                                    <span className="counter">25</span>+
                                                </h2>
                                                <p>Years of experience</p>
                                            </div>
                                            {/* About Us Image 2 Start */}
                                            <div className="about-us-img-3">
                                                <figure className="image-anime">
                                                    <img src="images/Untitled design (17).png" alt="" />
                                                </figure>
                                            </div>
                                            {/* About Us Image 2 End */}
                                        </div>
                                        {/* About Image Box 2 End */}
                                    </div>
                                </div>
                                {/* About Us Images End */}
                                <div className="col-xl-6">
                                    {/* About Us Content Start */}
                                    <div className="about-us-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">{t('pages.aboutH3')}</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.aboutH2')}</h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.aboutP1')}</p>
                                        </div>
                                        {/* Section Title End */}

                                        <div className="about-us-list-box">
                                            <div className="about-us-list wow fadeInUp" data-wow-delay="0.6s">
                                                <ul>
                                                    <li>{t('pages.aboutList1')}</li>
                                                    <li>{t('pages.aboutList2')}</li>
                                                    <li>{t('pages.aboutList3')}</li>
                                                </ul>
                                            </div>
                                            <div className="year-experience-circle">
                                                <img src="images/year-experience-circle.svg" alt="" />
                                            </div>
                                        </div>
                                        {/* About Us Button Start */}
                                        <div className="about-us-btn wow fadeInUp" data-wow-delay="0.8s">
                                            <Link to="/Contact" className="btn-default">{t('pages.aboutBtn')}</Link>
                                        </div>
                                        {/* About Us Button End */}
                                    </div>
                                    {/* About Us Content End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* About Us Section End */}
                    {/* Our Approach Section Start */}
                    <div className="our-approach bg-section">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    {/* Approach Content Start */}
                                    <div className="approach-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">{t('pages.approachH3')}</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.approachH2')}</h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.approachP')}</p>
                                        </div>
                                        {/* Section Title End */}
                                        {/* Approach Body Start */}
                                        <div className="approach-body wow fadeInUp" data-wow-delay="0.4s">
                                            {/* Approach Item Start */}
                                            <div className="approach-item">
                                                <div className="approach-item-header">
                                                    <div className="icon-box">
                                                        <img src="images/icon-mission.svg" alt="" />
                                                    </div>
                                                    <div className="approach-item-title">
                                                        <h3>{t('pages.missionTitle')}</h3>
                                                    </div>
                                                </div>
                                                <div className="approach-item-body">
                                                    <p>{t('pages.missionP')}</p>
                                                </div>
                                            </div>
                                            {/* Approach Item End */}
                                            {/* Approach Item Start */}
                                            <div className="approach-item">
                                                <div className="approach-item-header">
                                                    <div className="icon-box">
                                                        <img src="images/icon-vision.svg" alt="" />
                                                    </div>
                                                    <div className="approach-item-title">
                                                        <h3>{t('pages.visionTitle')}</h3>
                                                    </div>
                                                </div>
                                                <div className="approach-item-body">
                                                    <p>{t('pages.visionP')}</p>
                                                </div>
                                            </div>
                                            {/* Approach Item End */}
                                        </div>
                                        {/* Approach Body End */}

                                    </div>
                                    {/* Approach Content End */}
                                </div>
                                <div className="col-lg-6">
                                    {/* Approach Image Start */}
                                    <div className="approach-image">
                                        {/* Approach Image Box Start */}
                                        <div className="approach-img-box-1">
                                            <div className="approach-img-1">
                                                <figure className="image-anime ">
                                                    <img src="images/Untitled design (30).png" alt="" />

                                                </figure>
                                            </div>


                                        </div>
                                        {/* Approach Image Box End */}

                                    </div>
                                    {/* Approach Image End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Our Approach Section End */}

<br></br>

                    {/* Featival Vibes Section Start */}
                  
                    {/* Featival Vibes Section End */}


                    {/* Our Programs Section Start */}
                    <div className="our-programs bg-section dark-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5">
                                    {/* Our Programs Content Start */}
                                    <div className="our-programs-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">Our Activities</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">
                                                A Spectacular Dance Festival Awaits You
                                            </h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">
                                                Konark Patha Utsav presents a vibrant array of cultural experiences designed to engage and delight all visitors. A key highlight of this year’s festival is the Dance Festival, which will be organized during the first week of December 2025. This grand celebration of dance invites passionate performers from near and far to showcase their skills and cultural expressions on the iconic Konark street.
                                            </p>
                                        </div>
                                        {/* Section Title End */}
                                        {/* Our Programs Button Start */}
                                        <div
                                            className="our-programs-btn wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <Link to="/Event" className="btn-default btn-highlighted">
                                                Explore More
                                            </Link>
                                        </div>
                                        {/* Our Programs Button End */}
                                    </div>
                                    {/* Our Programs Content End */}
                                </div>
                                <div className="col-lg-7">
                                    {/* Programs Items List Start */}
                                    <div className="programs-items-list">
                                        {/* Programs Items Start */}
                                        <div className="programs-item wow fadeInUp">
                                            <div className="programs-item-image">
                                                <figure className="image-anime">
                                                    <img src="images/Untitled design (22).png" alt="" />
                                                </figure>
                                            </div>
                                            <div className="programs-item-content">
                                                <div className="programs-item-title">
                                                    <h3>Odissi</h3>
                                                    <p>
                                                        Classical Indian dance from Odisha, known for its graceful movements and expressive storytelling using intricate hand gestures.
                                                    </p>
                                                </div>
                                           
                                            </div>
                                        </div>
                                        {/* Programs Items End */}
                                        {/* Programs Items Start */}
                                        <div className="programs-item wow fadeInUp" data-wow-delay="0.2s">
                                            <div className="programs-item-image">
                                                <figure className="image-anime">
                                                    <img src="images/Untitled design (23).png" alt="" />
                                                </figure>
                                            </div>
                                            <div className="programs-item-content">
                                                <div className="programs-item-title">
                                                    <h3>Folk Dance</h3>
                                                    <p>
                                                        Traditional community dances reflecting local culture, rhythms, and celebrations, often performed in vibrant costumes.
                                                    </p>
                                                </div>
                                               
                                            </div>
                                        </div>
                                        {/* Programs Items End */}
                                        {/* Programs Items Start */}
                                        <div className="programs-item wow fadeInUp" data-wow-delay="0.4s">
                                            <div className="programs-item-image">
                                                <figure className="image-anime">
                                                    <img src="images/Untitled design (25).png" alt="" />
                                                </figure>
                                            </div>
                                            <div className="programs-item-content">
                                                <div className="programs-item-title">
                                                    <h3>Freestyle</h3>
                                                    <p>
                                                        A modern, improvisational dance style encouraging creativity and personal expression across diverse music genres.
                                                    </p>
                                                </div>
                                               
                                            </div>
                                        </div>
                                        {/* Programs Items End */}
                                    </div>
                                    {/* Programs Items List End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Our Programs Section End */}



                    {/* Our Testimonial Section Start */}
                 
                    {/* Our Testimonial Section End */}

                </>
<br></br>

                <Footer />
            </>

        </>
    );
}

export default About;